import DOMPurify from "dompurify";

// Certified R1 allowlist (R0 V1.7). Deny-by-default; no USE_PROFILES.
export const ALLOWED_TAGS = [
  "p", "strong", "em", "b", "i", "u", "ul", "ol", "li",
  "table", "thead", "tbody", "tr", "th", "td", "a", "br",
  "h2", "h3", "h4", "blockquote", "code",
];
export const ALLOWED_ATTR = ["href", "title", "colspan", "rowspan", "scope"];

const CONFIG = {
  ALLOWED_TAGS,
  ALLOWED_ATTR,
  ALLOW_DATA_ATTR: false,
  ALLOW_ARIA_ATTR: false,
  ALLOW_UNKNOWN_PROTOCOLS: false,
};

// Editorial tags that qualify a top-level element as a complete HTML fragment.
const EDITORIAL = new Set(ALLOWED_TAGS);

// Rendering-mode classifier (NOT the security boundary). Inert detached parse.
// HTML iff: >=1 top-level Element, >=1 top-level Element is editorial,
// and ZERO non-whitespace top-level Text nodes. Else PLAIN_TEXT.
export function classifyContent(value) {
  if (typeof value !== "string" || value.trim() === "") return "PLAIN_TEXT";
  const tpl = document.createElement("template"); // never appended to live DOM
  tpl.innerHTML = value;
  const nodes = Array.from(tpl.content.childNodes);
  const elements = nodes.filter((n) => n.nodeType === 1);
  if (elements.length === 0) return "PLAIN_TEXT";
  const hasEditorial = elements.some((el) => EDITORIAL.has(el.tagName.toLowerCase()));
  if (!hasEditorial) return "PLAIN_TEXT";
  const hasNonWsText = nodes.some((n) => n.nodeType === 3 && n.textContent.trim() !== "");
  if (hasNonWsText) return "PLAIN_TEXT";
  return "HTML";
}

// Sanitize trusted-but-untrusted editorial HTML before injection.
export function sanitize(html) {
  return DOMPurify.sanitize(typeof html === "string" ? html : "", CONFIG);
}
